import { render, staticRenderFns } from "./DashboardSingleValue.vue?vue&type=template&id=3828aa67"
import script from "./DashboardSingleValue.vue?vue&type=script&lang=js"
export * from "./DashboardSingleValue.vue?vue&type=script&lang=js"
import style0 from "./DashboardSingleValue.vue?vue&type=style&index=0&id=3828aa67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports